import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { isNullOrUndefined } from '../../utils/general'

/** The prompt content component */
export default class Prompt extends Component {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      value: !isNullOrUndefined(this.props.defaultValue) ? this.props.defaultValue : ''
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      this.props.onChange(this.state.value)
    }
  }

  onChange = e => this.setState({ value: e.target.value })

  render() {
    return (
      <input
        type="text"
        placeholder={this.props.placeholder}
        className="mm-popup__input"
        value={this.state.value}
        onChange={this.onChange}
      />
    )
  }
}
